/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ERPSyncProduct', 'model/ERPSyncProductReportERPSyncItemPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ERPSyncProduct'), require('../model/ERPSyncProductReportERPSyncItemPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPSyncProductApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ERPSyncProduct, root.ForStractionServiceApi.ERPSyncProductReportERPSyncItemPaginationSlice);
  }
}(this, function(ApiClient, ERPSyncProduct, ERPSyncProductReportERPSyncItemPaginationSlice) {
  'use strict';

  /**
   * ERPSyncProduct service.
   * @module api/ERPSyncProductApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ERPSyncProductApi. 
   * @alias module:api/ERPSyncProductApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the eRPSyncProductEditAllPut operation.
     * @callback module:api/ERPSyncProductApi~eRPSyncProductEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/ERPSyncProduct>} body 
     * @param {module:api/ERPSyncProductApi~eRPSyncProductEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPSyncProductEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPSyncProductEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling eRPSyncProductEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPSyncProduct/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPSyncProductGetDataPreviewGet operation.
     * @callback module:api/ERPSyncProductApi~eRPSyncProductGetDataPreviewGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'String'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getDataPreview
     * @param {String} _4SAPIAppID 
     * @param {module:api/ERPSyncProductApi~eRPSyncProductGetDataPreviewGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'String'>}
     */
    this.eRPSyncProductGetDataPreviewGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPSyncProductGetDataPreviewGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['String'];

      return this.apiClient.callApi(
        '/ERPSyncProduct/getDataPreview', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPSyncProductSearchAllSlicesPut operation.
     * @callback module:api/ERPSyncProductApi~eRPSyncProductSearchAllSlicesPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ERPSyncProductReportERPSyncItemPaginationSlice>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchAllSlices
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/ERPSyncProduct>} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.sortMode  (default to 0)
     * @param {String} opts.indicatorIDs  (default to )
     * @param {Date} opts.indicatorStartDate 
     * @param {Date} opts.indicatorEndDate 
     * @param {module:api/ERPSyncProductApi~eRPSyncProductSearchAllSlicesPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ERPSyncProductReportERPSyncItemPaginationSlice>}
     */
    this.eRPSyncProductSearchAllSlicesPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPSyncProductSearchAllSlicesPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling eRPSyncProductSearchAllSlicesPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxCount': opts['maxCount'],
        'sortMode': opts['sortMode'],
        'indicatorIDs': opts['indicatorIDs'],
        'indicatorStartDate': opts['indicatorStartDate'],
        'indicatorEndDate': opts['indicatorEndDate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ERPSyncProductReportERPSyncItemPaginationSlice];

      return this.apiClient.callApi(
        '/ERPSyncProduct/searchAllSlices', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPSyncProductSearchSlicePut operation.
     * @callback module:api/ERPSyncProductApi~eRPSyncProductSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ERPSyncProductReportERPSyncItemPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/ERPSyncProduct} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.sortMode  (default to 0)
     * @param {String} opts.indicatorIDs  (default to )
     * @param {Date} opts.indicatorStartDate 
     * @param {Date} opts.indicatorEndDate 
     * @param {module:api/ERPSyncProductApi~eRPSyncProductSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ERPSyncProductReportERPSyncItemPaginationSlice}
     */
    this.eRPSyncProductSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPSyncProductSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling eRPSyncProductSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'sortMode': opts['sortMode'],
        'indicatorIDs': opts['indicatorIDs'],
        'indicatorStartDate': opts['indicatorStartDate'],
        'indicatorEndDate': opts['indicatorEndDate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ERPSyncProductReportERPSyncItemPaginationSlice;

      return this.apiClient.callApi(
        '/ERPSyncProduct/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
